module.exports = __webpack_public_path__ + "static/colgadas-003-aa2d518323b9140ad0b49ad217c89720.jpg";